import React from "react";
import { useContext } from "react";
import BruttoNettoContext from "../BruttoNettoContext";
import { Tooltip as ReactTooltip } from "react-tooltip";

export default function Ergebnisse() {
  const { bruttoNettoState, handleBruttoNettoState } =
    useContext(BruttoNettoContext);

  return (
    <div>
      <p className="helper_margin1 lead">
        <label htmlFor="monthlyIncome">
          <b>
            <span className="monatslohn"> Monatslohn lfd.</span>
            <span className="tooltip" data-tooltip-id="tooltip2">
              ℹ️
            </span>
          </b>
        </label>
      </p>

      <div className="net-cost trc1 inputField">
        <input
          type="number"
          id="monthlyIncome"
          value={bruttoNettoState.bruttoGehalt}
          onChange={(event) =>
            handleBruttoNettoState("bruttoGehalt", Number(event.target.value))
          }
        />
      </div>
      <div className="form-field">
        <label htmlFor="deductionAmount">
          <div className=" trc2 result">
            Abzugsbetrag
            <span className="tooltip" data-tooltip-id="tooltip3">
              {" "}
              ℹ️
            </span>{" "}
          </div>
        </label>
        <div className=" trc1 inputField">
          <input
            type="number"
            id="deductionAmount"
            value={bruttoNettoState.abzugsBetrag}
            onChange={(event) =>
              handleBruttoNettoState("abzugsBetrag", Number(event.target.value))
            }
          />
        </div>
      </div>
      <div className="form-field">
        <div className=" trc2 result">
          <label htmlFor="deductionTax">
            Absetzbetrag
            <span className="tooltip" data-tooltip-id="tooltip4">
              {" "}
              ℹ️
            </span>{" "}
          </label>
        </div>
        <div className=" trc1 inputField">
          <input
            type="number"
            id="deductionTax"
            value={bruttoNettoState.steuerAbzug}
            onChange={(event) =>
              handleBruttoNettoState("steuerAbzug", Number(event.target.value))
            }
          />
        </div>
      </div>
      <ReactTooltip id="tooltip2" place="bottom" variant="info">
        <p>Mindestlohn gemäß Bäuerlichem KV beachten!</p>
      </ReactTooltip>
      <ReactTooltip id="tooltip3" place="bottom" variant="info">
        <p>
          Abzugsbetrag im Sinn einer Minderung der Steuer-Bemessungsgrundlage.
        </p>
        <p>132/12 Werbungskostenpauschale ist anwendbar.</p>
        <p> Weitere Abzüge für Transport & Familie prüfen!</p>
      </ReactTooltip>

      <ReactTooltip id="tooltip4" place="bottom" variant="info">
        <p>Absetzbetrag im Sinn einer Minderung der Steuer-Schuld.</p>
        <p>463/12 Verkehrsabsetzbetrag ist anwendbar.</p>
        <p> Weitere Abzüge für Transport & Familie prüfen!</p>
      </ReactTooltip>
    </div>
  );
}
